import { AdfDataMapperEntityType } from 'app/model/adfDataMapper/adfDataMapper.const';
import { DataFlowDataType } from 'worker/app-workers/shared/models/dataflow-datatype';

export interface IMapperViolationDetail {
    violationType: MapperViolationType;
    tableMappingIndex?: number;
    attributeMappingIndex?: number;
    previousAttributeMappingIndex?: number;
    targetAttribute?: string;
    sourceAttribute?: string;
    mappingMethod?: string;
    entityType?: AdfDataMapperEntityType;
    sourceTable?: string;
    targetTable?: string;
    functionName?: string;
    sourceDataType?: string;
    targetDataType?: string;
    tableType?: string;
    expectedDataTypes?: DataFlowDataType[];
}

export enum MapperViolationType {
    MappingMethod,
    SourceColumn,
    TargetColumn,
    OrphanSourceColumn,
    OrphanTargetColumn,
    InvalidSourceColumnDataType,
    InvalidTargetColumnDataType,
    InvalidTargetForComplexDataType,
    InvalidMappingForComplexDataType,
    NoTableMapping,
    NoColumnMapping,
    NoKeysSelected,
    InvalidMapping,
    NoTargetTableMapping,
    NoSourceTableMapping,
    MappingCombination,
    NoConnections,
    DuplicateSourceMapping,
    DuplicateTargetMapping,
    NoTablesForConnection,
    TableConfiguration,
    ConnectionConfiguration,
    Policy,
    StagingSettings,
    InvalidMethodForContinuousMapper
}

export enum MapperViolationCategory {
    TableMappingCanvas,
    ColumnMappingCanvas,
    StagingSettings
}

export interface IMapperViolationContext {
    violationCategory: MapperViolationCategory;
    violationType: MapperViolationType;
    targetConnectionIndex?: number;
    duplicateTargetConnectionIndex?: number;
    targetTableName?: string;
    sourceTableName?: string;
    tableIndex?: number;
    tableMappingIndex?: number;
    duplicateTableMappingIndex?: number;
    attributeMappingIndex?: number;
    previousAttributeMappingIndex?: number;
    mappingMethod?: string;
    targetAttributeName?: string;
    entityType?: AdfDataMapperEntityType;
}
